export enum DiscussionLoadMode {
    Populate = 1,
    UpdateLatestItemOnly = 2
}